// extracted by mini-css-extract-plugin
module.exports = {"progressBar":"#53b483"};